module.exports = __webpack_public_path__ + "assets/img/station14.9ba54ce1.png";